import { GraphQL } from "@rpi/openapi-api";

const eventTypeToPublicStatus = new Map<string, GraphQL.PublicOrderStatus>([
  // OrderEventType values (what the backend actually sends)
  ["ORDER_CREATED", GraphQL.PublicOrderStatus.Received],
  ["ORDER_RECEIVED", GraphQL.PublicOrderStatus.Received],
  ["ORDER_RECEIVED_INTO_LIMIT_QUEUE", GraphQL.PublicOrderStatus.Queued],
  ["ORDER_EXITED_LIMIT_QUEUE", GraphQL.PublicOrderStatus.Received],
  ["ORDER_EXCEEDS_LIMIT_QUEUE", GraphQL.PublicOrderStatus.Queued],
  ["ORDER_ASSETS_PROCESSED", GraphQL.PublicOrderStatus.Validating],
  ["ORDER_FINISHED_PRICING", GraphQL.PublicOrderStatus.ValidAwaitingPayment],
  ["ORDER_VALIDATION_FAILED", GraphQL.PublicOrderStatus.Failed],
  ["ORDER_ACCEPTED_BY_PRINTER", GraphQL.PublicOrderStatus.Printing],
  ["ORDER_ERRORED_BY_PRINTER", GraphQL.PublicOrderStatus.Exception],
  ["ORDER_VOIDED_BY_PRINTER", GraphQL.PublicOrderStatus.Cancelled],
  ["UOS_SUBMISSION", GraphQL.PublicOrderStatus.Printing],
  ["UOS_SUBMISSION_FAILED", GraphQL.PublicOrderStatus.Failed],
  ["ORDER_ATTEMPT_SUBMISSION", GraphQL.PublicOrderStatus.Printing],
  ["ORDER_MANUAL_UPDATE_RECEIVED", GraphQL.PublicOrderStatus.Printing],
  ["ORDER_SHIPPED", GraphQL.PublicOrderStatus.Shipped],
  ["ORDER_SHIPPED_PARTIALLY", GraphQL.PublicOrderStatus.Shipped],
  ["SHIPPING_ESTIMATE_REFRESHED", GraphQL.PublicOrderStatus.Printing],
  ["SHIPPING_REFRESH_SKIPPED", GraphQL.PublicOrderStatus.Printing],
  ["ORDER_CANCELLED", GraphQL.PublicOrderStatus.Cancelled],
  ["ORDER_CANCELLED_BEFORE_SUBMISSION", GraphQL.PublicOrderStatus.Cancelled],
  ["ORDER_CANCELLATION_REQUEST_SENT_TO_PRINTER", GraphQL.PublicOrderStatus.CancellationRequested],
  ["ORDER_FAILED", GraphQL.PublicOrderStatus.Failed],
  ["ORDER_EXCEPTION", GraphQL.PublicOrderStatus.Exception],
  ["PAYMENT_SUCCESS", GraphQL.PublicOrderStatus.Validating],
  ["PAYMENT_FAILURE", GraphQL.PublicOrderStatus.Failed],
  ["PAYMENT_PENDING", GraphQL.PublicOrderStatus.Validating],
  ["REFUND_SUCCESS", GraphQL.PublicOrderStatus.Cancelled],
  ["REFUND_ASYNC_FAILURE", GraphQL.PublicOrderStatus.Failed],
  ["ENTERED_HOLDING_BIN", GraphQL.PublicOrderStatus.ValidHoldingBin],
  ["EXITED_HOLDING_BIN", GraphQL.PublicOrderStatus.Validating],
  ["BYPASSED_HOLDING_BIN", GraphQL.PublicOrderStatus.Validating],
  ["REPRINT", GraphQL.PublicOrderStatus.Received],
  // OrderStatus values (used in design specs and status transitions)
  ["RECEIVED", GraphQL.PublicOrderStatus.Received],
  ["RECEIVED_OVER_LIMIT", GraphQL.PublicOrderStatus.Queued],
  ["CREATED", GraphQL.PublicOrderStatus.Received],
  ["ASSETS_PROCESSED", GraphQL.PublicOrderStatus.Validating],
  ["WAITING_FOR_TAXES", GraphQL.PublicOrderStatus.Validating],
  ["PRICING_COMPLETED", GraphQL.PublicOrderStatus.ValidAwaitingPayment],
  ["WAITING_IN_HOLDING_BIN", GraphQL.PublicOrderStatus.ValidHoldingBin],
  ["WAITING_FOR_SUBMISSION", GraphQL.PublicOrderStatus.ValidHoldingBin],
  ["SUBMITTING", GraphQL.PublicOrderStatus.Printing],
  ["SUBMITTED", GraphQL.PublicOrderStatus.Printing],
  ["CANCELLATION_REQUEST_SENT_TO_PRINTER", GraphQL.PublicOrderStatus.CancellationRequested],
  ["CANCELLED_BEFORE_SUBMISSION", GraphQL.PublicOrderStatus.Cancelled],
  ["CANCELLATION_ATTEMPTED", GraphQL.PublicOrderStatus.CancellationRequested],
  ["CANCELLED", GraphQL.PublicOrderStatus.Cancelled],
  ["FAILED", GraphQL.PublicOrderStatus.Failed],
  ["REJECTED", GraphQL.PublicOrderStatus.Rejected],
  ["EXCEPTION", GraphQL.PublicOrderStatus.Exception],
  ["SHIPPED", GraphQL.PublicOrderStatus.Shipped],
]);

export function getEventBadgeStatus(eventType: string | null | undefined): GraphQL.PublicOrderStatus | null {
  if (!eventType) return null;
  return eventTypeToPublicStatus.get(eventType) ?? null;
}

const KNOWN_ACRONYMS = new Set(["UOS", "SQS"]);

const toDisplayWord = (word: string): string =>
  KNOWN_ACRONYMS.has(word) ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

const stripOrderPrefix = (eventType: string): string =>
  eventType.startsWith("ORDER_") ? eventType.slice(6) : eventType;

export function formatEventTypeName(eventType: string | null | undefined): string {
  if (!eventType) return "Unknown";
  return stripOrderPrefix(eventType).split("_").map(toDisplayWord).join(" ");
}
